"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M8.301 17.98a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m11.926 2.219C20.223 11.112 12.833 3.75 3.778 3.75v3.143c7.381 0 13.357 5.977 13.362 13.357l3.088-.051z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M3.777 12.47a7.78 7.78 0 0 1 7.779 7.778l3.088-.05c0-6.009-4.863-10.875-10.871-10.871l.004 3.142z"
  })]
}), 'Rss');
